import './patientInsuranceDetailsComponent.scss'
import React, {useEffect} from 'react';
import PatientInsuranceViewEditComponent from "./patient-insurance-view-edit/patientInsuranceViewEditComponent";

interface PatientInsuranceDetailsComponentProps {
    patientID: string|undefined;
    onModeChange: Function;
    canEdit: boolean;
}

const PatientInsuranceDetailsComponent = (props: PatientInsuranceDetailsComponentProps) => {

        const {patientID,onModeChange,canEdit} = props;
        useEffect(()=>{
            onModeChange('view');
        })
        return (
            <div className="patient-information-component details-tab-data-wrapper">
                {
                    <PatientInsuranceViewEditComponent
                        patientID={patientID}
                        canEdit={canEdit}
                    />
                }
            </div>
        )
    }

;

export default PatientInsuranceDetailsComponent;